import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { ADD_PRODUCT_BACK_IN_STOCK_SUBSCRIPTION } from "../../operations/mutations/operations/mutations/add-product-back-in-stock-subscription.js";
const useAddBackInStockSubscription = () => {
  const { locale } = useIntl();
  const [isSubscribed, setIsSubscribed] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);
  const isBackInStockAlreadySubscribed = (data) => {
    return data?.addProductBackInStockSubscription?.__typename === "AddProductBackInStockSubscriptionFailureResponse" && data.addProductBackInStockSubscription.failures.some(
      (failure) => failure.__typename === "BackInStockAlreadySubscribedFailure"
    );
  };
  const [mutate, { error }] = useMutation(
    ADD_PRODUCT_BACK_IN_STOCK_SUBSCRIPTION,
    {
      onCompleted: (data) => {
        if (data.addProductBackInStockSubscription?.__typename === "AddProductBackInStockSubscriptionSuccessResponse" || isBackInStockAlreadySubscribed(data)) {
          setIsSubscribed(true);
          setHasError(false);
          toast.success("backInStock.signUpModal.toast.success");
        }
      },
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      },
      onError: () => {
        console.error("Back in stock subscription error:", error);
        setIsSubscribed(false);
        setHasError(true);
        toast.failed("backInStock.signUpModal.toast.error");
      }
    }
  );
  const addBackInStockSubscription = async ({
    email,
    sku
  }) => {
    try {
      const { data } = await mutate({ variables: { input: { email, sku } } });
      return data?.addProductBackInStockSubscription?.__typename === "AddProductBackInStockSubscriptionSuccessResponse" || isBackInStockAlreadySubscribed(data);
    } catch (error2) {
      console.error("Back in stock subscription mutation failed:", error2);
      return false;
    }
  };
  return { addBackInStockSubscription, isSubscribed, error: error || hasError };
};
export {
  useAddBackInStockSubscription
};
//# sourceMappingURL=use-add-back-in-stock-subscription.js.map
